  <div style="height: 87vh; width: 100vw;">

  <div class="plyr__video-embed" id="player">
    <iframe
      src="https://www.youtube.com/embed/1w0ArKYsWg8?autoplay=1&mute=1&iv_load_policy=3&modestbranding=1&playsinline=1&showinfo=0&rel=0&enablejsapi=1"
      allowfullscreen allowtransparency allow="autoplay"></iframe>
  </div>

  </div>



<br />
<app-title title="Sobre a Cancian"></app-title>

<div class="div-sobre">
  <p class="p-sobre">
  Fundada em 2012, a Cancian Imóveis se destaca por ser inovadora e pelo compromisso em oferecer atendimento ágil,
  transparente e seguro. Nossa dedicação tem como resultado a satisfação, fidelização e atração contínua de novos
  clientes, consolidando nossa posição como líder no mercado imobiliário.
  </p>

<div class="contadores">
  <div class="contador" *ngFor="let item of contadores">
    <div class="icone-contador" #contadoresSection>
      <i [class]="item.icone"></i>
    </div>
    <h3>{{ item.prefixo }}{{ formatarNumero(item.valor)  }}{{ item.sufixo }}</h3>
    <p> <b> {{ item.descricao }} </b> </p>
  </div>
</div>
</div>


<app-title title="Por que a Cancian?"></app-title>
<section class="section-whats">
    <div class="cards-wrapper">
    <div class="cards-container-whats">
      <div class="card-whats" *ngFor="let card of cards">
        <h3>{{ card.title }}</h3>
        <p>{{ card.content }}</p>
      </div>
    </div>
  </div>
</section>


<app-title title="Nossos Pilares"></app-title>
<section class="pilares-section">
  <div class="pilares-container">
    <div class="pilar-card" *ngFor="let pilar of pilares">
      <i [class]="pilar.icon"></i>
      <span>{{ pilar.label }}</span>
    </div>
  </div>
</section>





<app-title title="Proximidade que faz a diferença"></app-title>
<app-lojas></app-lojas>

<!-- 
<section class="content-client">
  <h1 class="title-2">
    O que dizem nossos clientes
    <div class="style-div"></div>
  </h1>
<div class="container-clientes">
  <div class="card-cliente">
    <img src="../../assets/corretor.webp" alt="Profile Picture">
    <div class="card-content">
      <div class="card-title-cli">Valnei Beltrame</div>
      <div class="card-sub-title-cli">Diretor e proprietário da Beltrame Casa e Construção</div>
      <div class="card-text-cli">Falar da Cancian Imóveis, é falar de uma empresa séria, <br>
        honesta, competente, que está há 10 anos no mercado <br>
        sendo uma empresa veterana. Temos parceira muito <br>
        boa, Beltrame com a Cancian, trabalhamos muito
      </div>
    </div>
  </div>

  <div class="card-cliente">
    <img src="../../assets/corretor.webp" alt="Profile Picture">
    <div class="card-content">
      <div class="card-title-cli">Alessandra Sehn</div>
      <div class="card-sub-title-cli">Diretor e proprietário da Beltrame Casa e Construção</div>
      <div class="card-text-cli">Falar da Cancian Imóveis, é falar de uma empresa séria, <br>
        honesta, competente, que está há 10 anos no mercado <br>
        sendo uma empresa veterana. Temos parceira muito <br>
        boa, Beltrame com a Cancian, trabalhamos muito
      </div>
    </div>
  </div>

  <div class="card-cliente">
    <img src="../../assets/corretor.webp" alt="Profile Picture">
    <div class="card-content">
      <div class="card-title-cli">Lucas Ruppelt</div>
      <div class="card-sub-title-cli">Diretor e proprietário da Beltrame Casa e Construção</div>
      <div class="card-text-cli">Falar da Cancian Imóveis, é falar de uma empresa séria, <br>
        honesta, competente, que está há 10 anos no mercado <br>
        sendo uma empresa veterana. Temos parceira muito <br>
        boa, Beltrame com a Cancian, trabalhamos muito
      </div>
    </div>
  </div>

  <div class="card-cliente">
    <img src="../../assets/corretor.webp" alt="Profile Picture">
    <div class="card-content">
      <div class="card-title-cli">Fernando Weber</div>
      <div class="card-sub-title-cli">Diretor e proprietário da Beltrame Casa e Construção</div>
      <div class="card-text-cli">Falar da Cancian Imóveis, é falar de uma empresa séria, <br>
        honesta, competente, que está há 10 anos no mercado <br>
        sendo uma empresa veterana. Temos parceira muito <br>
        boa, Beltrame com a Cancian, trabalhamos muito
      </div>
    </div>
  </div>
</div>
</section> -->

<!-- <section class="content-2">
  <div class="container-financie" 
  style="background: none!important; border: 1px solid #ddd; border-radius: 25px; margin: 50px auto;">
    
    <div class="right-first" style="justify-content: start!important;">
      <img src="../../assets/acessando-mulher-com-notebook.jpg" alt="" />
    </div>
  
    <div class="right">
      <div class="content">
        <div class="titulo">
          <h2 style="margin-bottom: 40px!important; font-size: 3rem!important;">
            Precisa de ajuda?<br>
            Fale com nosso time:
          </h2>
  
          <div class="form-container">
            <div class="form-group">
              <label for="nome">Nome</label>
              <input type="text" id="nome" placeholder="Coloque seu nome" />
            </div>
          
            <div class="form-group">
              <label for="telefone">Telefone</label>
              <input type="text" id="telefone" placeholder="Coloque seu WhatsApp" />
            </div>
          
            <div class="form-group full-width">
              <label for="duvida">Qual sua dúvida?</label>
              <select id="duvida" style="padding: 8px 0 10px 10px; margin-right: 20px;">
                <option value="" disabled selected>Escolha sua dúvida</option>
                <option value="op1">Dúvida sobre produtos</option>
                <option value="op2">Dúvida sobre serviços</option>
                <option value="op3">Dúvida sobre suporte técnico</option>
              </select>
            </div>
          </div>
          <div class="div-btn-financie">
            <button type="button" class="btn-large-red">Enviar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section> -->